export enum RowAction {
    EDIT = 'edit',
    DELETE = 'delete',
    DETAILS = 'details',
    COPY = 'copy',
  }